<form *ngIf="!showCadastroModal" [formGroup]="formConsulta" (ngSubmit)="PesquisarPlanos()">
  <!-- Breadcrumb -->
  <breadcrumb
    [paginas]="[
      { route: '/home', name: 'Home' },
      { route: '/plano-contingencia/consulta', name: 'Planos de contingência' }
    ]"
  />

  <!-- FILTROS (URE e Escola – Polo removido) -->
  <section class="section-filtro">
    <div class="container">
      <!-- URE -->
      <div class="grupo-filter">
        <p><b>URE</b></p>
        <ng-select
          [items]="diretorias"
          bindLabel="nomeDiretoria"
          bindValue="codigoDiretoria"
          placeholder="Selecione uma URE"
          formControlName="codigoDiretoria"
          name="codigoDiretoria"
          (change)="getEscolas()"
          [ngClass]="{ 'is-invalid': submitted && form.codigoDiretoria.errors }"
        >
        </ng-select>
        <div *ngIf="submitted && form.codigoDiretoria.errors" class="alert">
          <div *ngIf="form.codigoDiretoria.errors.required">
            * URE é obrigatório
          </div>
        </div>
      </div>

      <!-- Escola -->
      <div class="grupo-filter">
        <p><b>Escola</b></p>
        <ng-select
          [items]="escolas"
          bindLabel="nomeEscola"
          bindValue="codigoEscola"
          placeholder="Selecione uma Escola"
          formControlName="codigoEscola"
          (change)="PesquisarPlanos()"
        >
        </ng-select>
      </div>


      <!-- Botão Buscar -->
      <button type="submit" class="btn-search-filtro">
        <img
          src="../../../../assets/img/icons/icon-search.svg"
          alt="Pesquisar"
          title="Pesquisar"
        />
      </button>
    </div>
  </section>

  <!-- TÍTULO + BOTÃO CADASTRAR (layout referência) -->
  <section class="section-saudacao">
    <div class="container">
      <div class="row_registros">
        <h2 class="titulo-page">Planos de contingência</h2>
        <button
          *ngIf="mostrarBotaoCadastrar()"
          type="button"
          class="btn_adicionar_registro"
          title="Cadastrar plano"
          (click)="navigateToCadastrarPlano()">
          <i class="fa fa-plus" aria-hidden="true"></i> Cadastrar plano
        </button>
      </div>
    </div>
  </section>

  <!-- LISTAGEM -->
  <section class="conteudo-principal">
    <div class="container">
      <div class="titulo-legenda">
        <div class="legenda legenda-direita">
          <p class="legenda-titulo">Legenda</p>
          <div class="legenda-itens">
            <span><i class="fa fa-eye"></i> Visualizar</span>
            <span><i class="fa fa-check-square"></i> Aprovar</span>
            <span><i class="fa fa-times"></i> Reprovar</span>
          </div>
        </div>
      </div>

      <!-- Grid da tabela (Ano, Nome da Escola, Nome, Data de registro, Vigência, Status, Ações) -->
    <div class="grid-datatable">
      <table
        datatable
        [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger"
        class="row-border"
        aria-describedby="planos"
      >
        <thead>
          <tr>
            <th scope="col">Ano</th>
            <th scope="col">Nome da Escola</th>
            <th scope="col">Nome</th>
            <th scope="col">Data de registro</th>
            <th scope="col">Vigência</th>
            <th scope="col">Status</th>
            <th scope="col">Ações</th>
          </tr>
          <tr class="row-filtro-coluna">
            <th scope="col"><input type="text" class="input-filtro-coluna" [(ngModel)]="filterAno" [ngModelOptions]="{standalone: true}" placeholder="" /></th>
            <th scope="col"><input type="text" class="input-filtro-coluna" [(ngModel)]="filterNomeEscola" [ngModelOptions]="{standalone: true}" placeholder="" /></th>
            <th scope="col"><input type="text" class="input-filtro-coluna" [(ngModel)]="filterNome" [ngModelOptions]="{standalone: true}" placeholder="" /></th>
            <th scope="col"><input type="text" class="input-filtro-coluna" [(ngModel)]="filterDataRegistro" [ngModelOptions]="{standalone: true}" placeholder="" /></th>
            <th scope="col"><input type="text" class="input-filtro-coluna" [(ngModel)]="filterVigencia" [ngModelOptions]="{standalone: true}" placeholder="" /></th>
            <th scope="col"><input type="text" class="input-filtro-coluna" [(ngModel)]="filterStatus" [ngModelOptions]="{standalone: true}" placeholder="" /></th>
            <th scope="col"><input type="text" class="input-filtro-coluna" placeholder="" readonly /></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of filteredPlanos; trackBy: trackByCdPlano" [attr.data-status]="getStatusNumero(item)" [class.ocultar-excluir]="deveOcultarExcluirPorStatus(item)">
            <td>{{ item.vigencia }}</td>
            <td>{{ item.nmEscola || '—' }}</td>
            <td>{{ item.nomeResponsavel || '—' }}</td>
            <td>{{ (item.dataRevisao || item.dataInclusao) ? ((item.dataRevisao || item.dataInclusao) | date:'dd/MM/yyyy') : '—' }}</td>
            <td>{{ item.vigencia || '—' }}</td>
            <td>
              <span class="status-celula">
                <span class="status-bolinha" [ngClass]="getClasseBolinhaStatus(item.status)" aria-hidden="true">&nbsp;</span>
                <span class="status-texto">{{ getTextoStatus(item.status) }}</span>
              </span>
            </td>
            <td class="col-acoes">
              <span class="acoes-linha">
                <a href="javascript:void(0)" (click)="abrirModalVisualizar(item.cdPlano)">
                  <i class="fa fa-eye" title="Visualizar"></i>
                </a>
                <ng-container *ngIf="podeAprovarOuReprovar(item)">
                  <a href="javascript:void(0)" class="acao-aprovar" (click)="abrirModalConfirmacao(item, 'aprovar')">
                    <i class="fa fa-check-square" title="Aprovar"></i>
                  </a>
                  <a href="javascript:void(0)" class="acao-reprovar" (click)="abrirModalConfirmacao(item, 'reprovar')">
                    <i class="fa fa-times" title="Reprovar"></i>
                  </a>
                </ng-container>
                <!-- Editar: Aprovado = só anexos/riscos; Aguardando validação = somente leitura; demais = edição completa. -->
                <ng-container *ngIf="mostrarEditar(item)">
                  <a href="javascript:void(0)" class="acao-editar" (click)="abrirModalCadastro(item)">
                    <i class="fa fa-pencil" [title]="itemEstaAguardandoValidacao(item) ? 'Visualizar (somente leitura)' : 'Editar'"></i>
                  </a>
                </ng-container>
                <!-- Enviar para validação → status "Aguardando Validação Supervisor de Ensino". Habilitado para Novo e Devolvido para ajustes. -->
                <ng-container *ngIf="podeEnviarParaValidacao(item)">
                  <a href="javascript:void(0)" (click)="abrirModalEnviarValidacao(item.cdPlano, item.vigencia, item.nmEscola)">
                    <i class="fa-solid fa-arrows-rotate" title="Enviar para Validação"></i>
                  </a>
                </ng-container>
                <!-- Cenário 2: Excluir → somente se o plano não estiver aprovado. -->
                <ng-container *ngIf="podeExcluir(item)">
                  <a href="javascript:void(0)" class="acao-excluir" (click)="abrirModalExcluir(item)">
                    <i class="fa fa-trash" title="Excluir"></i>
                  </a>
                </ng-container>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
</section>
</form>

<!-- Modal Histórico de atualizações (layout timeline: data/hora, tipo, responsável) -->
<app-modal *ngIf="showModalHistorico" class="modal-historico-atualizacoes">
  <div class="modal-historico-atualizacoes__conteudo">
    <h2 class="modal-historico-atualizacoes__titulo">Histórico de atualizações</h2>
    <div class="modal-historico-atualizacoes__lista" *ngIf="(planoSelecionado?.logs ?? []).length > 0">
      <div *ngFor="let log of (planoSelecionado?.logs ?? []); let i = index" class="modal-historico-atualizacoes__item">
        <span class="modal-historico-atualizacoes__ponto" aria-hidden="true"></span>
        <div class="modal-historico-atualizacoes__bloco">
          <div class="modal-historico-atualizacoes__linha-data">
            <span class="modal-historico-atualizacoes__data">{{ (log.dataOperacao | date:'dd/MM/yyyy, HH:mm') || '—' }}</span>
            <span class="modal-historico-atualizacoes__tipo" *ngIf="getTextoOperacaoLog(log)">{{ getTextoOperacaoLog(log) }}</span>
          </div>
          <p class="modal-historico-atualizacoes__responsavel" [class.modal-historico-atualizacoes__responsavel--id]="ehIdResponsavel(log.nomeResponsavelLog)">
            <i class="fa fa-user" aria-hidden="true"></i>
            {{ log.nomeResponsavelLog || '—' }}
          </p>
        </div>
      </div>
    </div>
    <p *ngIf="planoSelecionado && (!planoSelecionado.logs || planoSelecionado.logs.length === 0)" class="modal-historico-atualizacoes__vazio">Nenhuma atualização registrada.</p>
    <div class="modal-historico-atualizacoes__footer">
      <button type="button" class="modal-historico-atualizacoes__btn-fechar" (click)="fecharModalHistorico()">Fechar</button>
    </div>
  </div>
</app-modal>

<!-- Visualização do anexo: fora do modal para não disparar destroy do DataTables; z-index alto para ficar por cima -->
<div class="wrapper-visualizar-anexo-acima" *ngIf="showModalVisualizarArquivo && arquivoVisualizando">
  <app-visualizar-arquivo
    [arquivo]="arquivoVisualizando"
    (fechar)="fecharModalVisualizarArquivo()">
  </app-visualizar-arquivo>
</div>

<!-- Modal Aprovar / Reprovar (layout referência: aprovar com ícone verde, aviso, detalhes) -->
<app-modal *ngIf="showModalConfirmacao" class="modal-confirmacao-plano" [ngClass]="{'modal-confirmacao-plano--reprovar': acaoModal === 'reprovar'}">
  <div class="modal-confirmacao-plano__conteudo">
    <!-- Cabeçalho com ícone -->
    <div class="modal-confirmacao-plano__header" [ngClass]="{'modal-confirmacao-plano__header--reprovar': acaoModal === 'reprovar'}">
      <span class="modal-confirmacao-plano__icone" aria-hidden="true">
        <i class="fa" [ngClass]="acaoModal === 'aprovar' ? 'fa-check-circle' : 'fa-times-circle'"></i>
      </span>
    </div>
    <!-- Corpo -->
    <div class="modal-confirmacao-plano__body">
      <h3 class="modal-confirmacao-plano__titulo">
        Tem certeza de que deseja {{ acaoModal === 'aprovar' ? 'aprovar' : 'reprovar' }}?
      </h3>

      <div *ngIf="acaoModal === 'aprovar'" class="modal-confirmacao-plano__aviso">
        <span class="modal-confirmacao-plano__aviso-icone" aria-hidden="true"><i class="fa fa-exclamation" aria-hidden="true"></i></span>
        <span class="modal-confirmacao-plano__aviso-texto">Atenção: Depois da aprovação, a única modificação permitida será a inclusão de anexos aos riscos.</span>
      </div>

      <!-- Detalhes: aprovar = Ano + Escola; reprovar = Ano + Nome da Escola + Data de registro -->
      <div class="modal-confirmacao-plano__detalhes">
        <p class="modal-confirmacao-plano__detalhes-titulo">Detalhes</p>
        <div class="modal-confirmacao-plano__campos">
          <div class="modal-confirmacao-plano__campo">
            <label>Ano</label>
            <input type="text" [value]="anoModalConfirmacao" readonly />
          </div>
          <ng-container *ngIf="acaoModal === 'reprovar'">
            <div class="modal-confirmacao-plano__campo">
              <label for="escolaModalConfirmacao1">Nome da Escola</label>
              <input id="escolaModalConfirmacao1" type="text" [value]="escolaModalConfirmacao" readonly />
            </div>
            <div class="modal-confirmacao-plano__campo">
              <label for="dataRegistroModalConfirmacao">Data de registro</label>
              <input id="dataRegistroModalConfirmacao" type="text" [value]="dataRegistroModalConfirmacao" readonly />
            </div>
          </ng-container>
          <div *ngIf="acaoModal === 'aprovar'" class="modal-confirmacao-plano__campo">
            <label for="escolaModalConfirmacao2">Escola</label>
            <input id="escolaModalConfirmacao2" type="text" [value]="escolaModalConfirmacao" readonly />
          </div>
        </div>
      </div>

      <div *ngIf="acaoModal === 'reprovar'" class="modal-confirmacao-plano__reprovar">
        <label for="justificativa">Motivo da reprovação *</label>
        <textarea
          id="justificativa"
          [(ngModel)]="justificativa"
          rows="4"
          maxlength="1000"
          placeholder="Insira o motivo da reprovação">
        </textarea>
        <div class="modal-confirmacao-plano__contador">{{ justificativa?.length || 0 }}/1000</div>
      </div>

      <div class="modal-confirmacao-plano__botoes">
        <button type="button" class="modal-confirmacao-plano__btn modal-confirmacao-plano__btn--cancelar" (click)="fecharModalConfirmacao()">Cancelar</button>
        <button type="button" class="modal-confirmacao-plano__btn modal-confirmacao-plano__btn--confirmar" (click)="confirmarAcao()">Confirmar</button>
      </div>
    </div>
  </div>
</app-modal>

<!-- Modal de exclusão -->
<app-modal *ngIf="showModalExcluir" class="modal-exclusao-plano">
  <div class="modal-exclusao-plano__conteudo">
    <div class="modal-exclusao-plano__header">
      <span class="modal-exclusao-plano__icone" aria-hidden="true">
        <i class="fa fa-times" aria-hidden="true"></i>
      </span>
    </div>
    <div class="modal-exclusao-plano__body">
      <h3 class="modal-exclusao-plano__titulo">Tem certeza de que deseja excluir o Plano de Contingência?</h3>
      <div class="modal-exclusao-plano__detalhes">
        <p class="modal-exclusao-plano__detalhes-titulo">Detalhes</p>
        <div class="modal-exclusao-plano__campos">
          <div class="modal-exclusao-plano__campo">
            <label>Ano</label>
            <input type="text" [value]="anoModalExcluir" readonly />
          </div>
          <div class="modal-exclusao-plano__campo">
            <label>Escola</label>
            <input type="text" [value]="escolaModalExcluir" readonly />
          </div>
        </div>
      </div>
      <div class="modal-exclusao-plano__botoes">
        <button type="button" class="modal-exclusao-plano__btn modal-exclusao-plano__btn--cancelar" (click)="fecharModalExcluir()">Cancelar</button>
        <button type="button" class="modal-exclusao-plano__btn modal-exclusao-plano__btn--confirmar" (click)="confirmarExcluir()">Confirmar</button>
      </div>
    </div>
  </div>
</app-modal>

<!-- Modal Enviar para Validação -->
<app-modal *ngIf="showModalEnviarValidacao" class="modal-enviar-validacao">
  <div class="modal-enviar-validacao__conteudo">
    <div class="modal-enviar-validacao__header">
      <span class="modal-enviar-validacao__icone" aria-hidden="true">
        <i class="fa-solid fa-arrows-rotate" aria-hidden="true"></i>
      </span>
    </div>
    <div class="modal-enviar-validacao__body">
      <h3 class="modal-enviar-validacao__titulo">Tem certeza de que deseja enviar para validação?</h3>
      <div class="modal-enviar-validacao__aviso">
        <span class="modal-enviar-validacao__aviso-icone" aria-hidden="true"><i class="fa fa-exclamation" aria-hidden="true"></i></span>
        <span class="modal-enviar-validacao__aviso-texto">Atenção: Depois da aprovação, a única modificação permitida será a inclusão de anexos aos riscos.</span>
      </div>
      <div class="modal-enviar-validacao__detalhes">
        <p class="modal-enviar-validacao__detalhes-titulo">Detalhes</p>
        <div class="modal-enviar-validacao__campos">
          <div class="modal-enviar-validacao__campo">
            <label>Ano</label>
            <input type="text" [value]="anoModalEnviar" readonly />
          </div>
          <div class="modal-enviar-validacao__campo">
            <label>Escola</label>
            <input type="text" [value]="escolaModalEnviar" readonly />
          </div>
        </div>
      </div>
      <div class="modal-enviar-validacao__botoes">
        <button type="button" class="modal-enviar-validacao__btn modal-enviar-validacao__btn--cancelar" (click)="fecharModalEnviarValidacao()">Cancelar</button>
        <button type="button" class="modal-enviar-validacao__btn modal-enviar-validacao__btn--confirmar" (click)="confirmarEnviarValidacao()">Confirmar</button>
      </div>
    </div>
  </div>
</app-modal>

<div *ngIf="showCadastroModal" class="formulario-tela-cheia">
  <div class="container-conviva form-registro formulario-tela-cheia__conteudo">
    <app-plano-contingencia-cadastro [planoContingencia]="planoSelecionado" [ehModal]="true" [ehEdicao]="ehEdit"
      [ehReadOnly]="ehReadOnly || ehReadOnlyCadastro" [tituloAcaoModal]="tituloAcaoModal" [statusPlano]="statusPlano"
      [somenteAnexosERiscos]="somenteAnexosERiscos"
      (fechar)="FecharCadastroModal()">
    </app-plano-contingencia-cadastro>
  </div>
</div>

<!-- Spinner -->
<ngx-spinner
  bdColor="rgba(51,51,51,0.8)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
>
  <p style="font-size: 20px; color: white">Carregando ...</p>
</ngx-spinner>
